import {
  LayersNodes,
  RelatedNode,
} from '@components/MainStage/ContextMenu/RelationshipsMenu/constants/types';
import { connectableLayers, nodeTypesByMode } from '@constants/canvas/general';
import {
  ChangeInitiativesSubLayerTypes,
  InitiativesSubLayerTypes,
  Modes,
  ReadableSubLayerTitles,
  SubLayerTypes,
} from '@constants/canvas/layers';
import { canvasMap } from '@utils/canvas/CanvasMap';

export const getParentSubLayers = (
  mode: Modes,
  focusedSubLayer: SubLayerTypes,
) => {
  const allowedSubLayers = nodeTypesByMode[mode] as SubLayerTypes[];

  const parentSubLayers = Object.entries(connectableLayers).reduce<
    SubLayerTypes[]
  >((acc, [parent, connectable]) => {
    const isParentAllowed = allowedSubLayers.includes(parent as SubLayerTypes);

    const isIncludes = (connectable as SubLayerTypes[]).includes(
      focusedSubLayer,
    );

    if (isParentAllowed && isIncludes) {
      acc.push(parent as SubLayerTypes);
    }

    return acc;
  }, []);

  return { parentSubLayers };
};

export const getChildSubLayer = (
  mode: Modes,
  focusedSubLayer: SubLayerTypes,
) => {
  const allowedSubLayers = nodeTypesByMode[mode] as SubLayerTypes[];

  return {
    childSubLayers: (
      (connectableLayers[focusedSubLayer] as SubLayerTypes[]) ?? []
    ).filter((layer) => allowedSubLayers.includes(layer)),
  };
};

export const getSectionTitle = (mode: Modes, layer: SubLayerTypes) => {
  if (
    mode === Modes.RiskManagement &&
    layer === InitiativesSubLayerTypes.ChangeInitiatives
  ) {
    return `To ${ReadableSubLayerTitles[
      ChangeInitiativesSubLayerTypes.RemediationAction
    ].toLowerCase()}`;
  }

  return `To ${ReadableSubLayerTitles[layer].toLowerCase()}`;
};

export const generateLayersNodes = (
  ids: string[],
  filterSubLayers: SubLayerTypes[],
) => {
  return ids.reduce<LayersNodes>((acc, nodeId) => {
    const node = canvasMap.nodeMap.get(nodeId);

    if (node) {
      const nodeSubLayer = node.parentNode as SubLayerTypes;

      if (filterSubLayers.includes(nodeSubLayer)) {
        const {
          data: {
            dto: { name, type, meta_data },
          },
        } = node;

        const relatedNode: RelatedNode = {
          id: nodeId,
          name,
          type,
          initiativeType: meta_data.type,
        };

        acc[nodeSubLayer] = [...(acc[nodeSubLayer] ?? []), relatedNode];
      }
    }

    return acc;
  }, {} as LayersNodes);
};
